import { createStore } from "owa-satcheljs";

interface MyOutlookViewState {
    isFullPageShowing: boolean;
    isSectionHidden: boolean;
}

const getMyOutlookViewState: () => MyOutlookViewState = createStore<MyOutlookViewState>("MyOutlookViewState", {
    isFullPageShowing: false,
    isSectionHidden: false,
});

export default getMyOutlookViewState;
